import { Pipe, PipeTransform } from '@angular/core';
import { SubmissionPermissionTypeEnum } from '../models/permissions/enum/submission-permission-type.enum';

export type SubmissionPermissionAudience = 'member' | 'employer';

@Pipe({
  name: 'submissionPermissionTooltip',
  standalone: true
})
export class SubmissionPermissionTooltipPipe implements PipeTransform {
  transform(typeId: SubmissionPermissionTypeEnum, audience: SubmissionPermissionAudience): string {
    switch (typeId) {
      case SubmissionPermissionTypeEnum.View:
        return $localize`Allows user to view submission details`;
      case SubmissionPermissionTypeEnum.Process:
        return $localize`Allows user to be the owner of a submission and makes them available in the queue for submission assignment`;
      case SubmissionPermissionTypeEnum.Approve:
        return $localize`Allows user to approve the submission`;
      case SubmissionPermissionTypeEnum.ApproveOwn:
        return $localize`Allows user to own and approve submission without secondary approval`;
      case SubmissionPermissionTypeEnum.Override:
        return $localize`Allows user to change the submission owner and/or approver without being assigned to the submission themselves`;
      case SubmissionPermissionTypeEnum.Create:
        return audience === 'employer'
          ? $localize`Allows user to create submissions on the employer's behalf`
          : $localize`Allows user to create submissions on the member's behalf`;
      default:
        return '';
    }
  }
}
